/**
 * fileToResizedDataUrl — reads an image File and returns a small JPEG data URL.
 *
 * WHY RESIZE ON THE DEVICE: the customer profile has no login yet, so the photo
 * is stored locally (in the browser). A full-size phone photo is several MB —
 * too big for localStorage and pointless for a tiny avatar. We draw it onto a
 * canvas capped at `max` pixels and export a compressed JPEG, so the stored
 * string stays ~30–50 KB.
 *
 * @param {File} file
 * @param {number} [max=256] - longest edge, in pixels
 * @returns {Promise<string>} a data: URL
 */
export function fileToResizedDataUrl(file, max = 256) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Could not read the image'));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error('That file is not a valid image'));
      img.onload = () => {
        const scale = Math.min(1, max / Math.max(img.width, img.height));
        const w = Math.round(img.width * scale);
        const h = Math.round(img.height * scale);

        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);

        resolve(canvas.toDataURL('image/jpeg', 0.85));
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}

export default fileToResizedDataUrl;
